var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/sayt-trending.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "trendingData")) > 0) {
output += "\n\n    <div class=\"c-sayt-trending\">\n\n        <h3 class=\"c-sayt-trending__h3\">";
output += runtime.suppressValue((lineno = 4, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["sayt_trending_heading"])), env.opts.autoescape);
output += "</h3>\n\n        <ul class=\"c-sayt-trending__ul js-site-search-sayt__ul\">\n\n            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "trendingData");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("keyword", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n                <li class=\"c-sayt-trending__li js-site-search-sayt__li\">\n\n                    <a class=\"c-sayt-trending__a js-search-suggestion\"\n                        href=\"";
output += runtime.suppressValue((lineno = 13, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "searchUrl"), "searchUrl", context, ["q=" + "" + env.getFilter("replace").call(context, env.getFilter("urlencode").call(context, t_4),"%20","+")])), env.opts.autoescape);
output += "\"\n                        data-suggestion-index=\"t";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\"\n                        data-suggestion-type=\"trending\"\n                        data-qa-trending-term>\n\n                        ";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "\n\n                    </a>\n\n                </li>\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        </ul>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/sayt-trending.j2"] , dependencies)